import React from 'react';
import { useTranslation } from 'react-i18next';
import './RoleBadge.css';

interface RoleBadgeProps {
  role: string;
  scope?: string;
}

type RoleType = 'super-admin' | 'global-admin' | 'agent-admin' | 'technician' | 'unknown';

export const RoleBadge: React.FC<RoleBadgeProps> = ({ role, scope }) => {
  const { t } = useTranslation();

  const getRoleType = (): RoleType => {
    const normalizedRole = role?.toUpperCase();
    const normalizedScope = scope?.toLowerCase();

    if (normalizedRole === 'SUPER_ADMIN') {
      return 'super-admin';
    }
    if (normalizedRole === 'ADMIN' && normalizedScope === 'global') {
      return 'global-admin';
    }
    if (normalizedRole === 'ADMIN' && normalizedScope === 'agent') {
      return 'agent-admin';
    }
    if (normalizedRole === 'TECHNICIAN') {
      return 'technician';
    }
    return 'unknown';
  };

  const getRoleLabel = (roleType: RoleType): string => {
    switch (roleType) {
      case 'super-admin':
        return t('roles.superAdmin');
      case 'global-admin':
        return t('roles.globalAdmin');
      case 'agent-admin':
        return t('roles.agentAdmin');
      case 'technician':
        return t('roles.technician');
      default:
        return role;
    }
  };

  const roleType = getRoleType();
  const label = getRoleLabel(roleType);

  return (
    <span className={`role-badge role-badge--${roleType}`}>
      {label}
    </span>
  );
};

export default RoleBadge;
